exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-detective-wall-tsx": () => import("./../../../src/pages/detective-wall.tsx" /* webpackChunkName: "component---src-pages-detective-wall-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-level-levels-yaml-level-tsx": () => import("./../../../src/pages/level-{levelsYaml.level}.tsx" /* webpackChunkName: "component---src-pages-level-levels-yaml-level-tsx" */)
}

